import { useEffect, useRef, useState } from 'react';
import FormNavigationLink from '../FormNavigationLink';
import { UserSessionHelper } from '@/library';
import ArrowDownIcon from '@/assets/icons/arrow-down.svg?react';
import styles from './NavigationSelect.module.scss';

interface Option {
  page: string;
  label: string;
}

interface NavigationSelectProps {
  placeholder: string; // persistent placeholder, e.g. "Reports"
  options: Option[];
  className?: string;
}

function NavigationSelect({ placeholder, options, className = '' }: NavigationSelectProps) {
  const [open, setOpen] = useState(false);
  const [token, setToken] = useState<string>('');
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const getToken = async () => {
      const token = await UserSessionHelper.getToken();
      setToken(token || '');
    };
    getToken();
    const handleClickOutside = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={`${styles.wrapper} ${className}`} ref={wrapperRef}>
      <button className={styles.selectButton} type="button" onClick={() => setOpen((prev) => !prev)}>
        {placeholder}
        <ArrowDownIcon className={styles.arrowDownIcon} />
      </button>
      {open && (
        <div className={styles.dropdown}>
          {options.map(({ page, label }) => (
            <FormNavigationLink key={label} page={page} label={label} token={token} className={styles.option} />
          ))}
        </div>
      )}
    </div>
  );
}

export default NavigationSelect;
